import { Stack } from "@mui/material";
import { EnergyAnalysisConfigChip } from "features/energy-analysis-dashboard/components/EnergyAnalysisConfigChip";
import type { CrremSettings } from "features/energy-analysis-dashboard/model/types";
import { useTranslation } from "react-i18next";

import type { CrremPathwayScale } from "../model/types";

import { CRREM_PATHWAY_SCALE } from "../model/constants";

type CrremPathwaySettingsBadgesProps = {
  scale: CrremPathwayScale;
  settings: CrremSettings;
};

export const CrremPathwaySettingsBadges = ({ scale, settings }: CrremPathwaySettingsBadgesProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="min-w-0 flex-wrap items-center gap-2">
      <EnergyAnalysisConfigChip
        iconName="Sorting"
        label={t(`BuildingProfile.energyAnalysis.settings.${settings.trendMethod}`)}
        variant="info"
      />
      {scale === CRREM_PATHWAY_SCALE.none ? null : (
        <EnergyAnalysisConfigChip
          className="bg-core-vivid-orchid-50 text-core-vivid-orchid-700"
          iconName="BuildingIcon"
          label={t(`BuildingProfile.energyAnalysis.settings.${scale}`)}
          variant="info"
        />
      )}
    </Stack>
  );
};
